import { Radio, RadioGroup as RadioGroupHeadless } from '@headlessui/react';
import { useState } from 'react';

interface RadioOption {
  value: string;
  content: React.ReactNode;
}

interface RadioGroupProps {
  items: RadioOption[];
  defaultValue: string;
  onChange?: (value: string) => void;
  className?: string;
}

export const RadioGroup = ({
  items,
  defaultValue,
  onChange,
  className,
}: RadioGroupProps) => {
  const [selectedOption, setSelectedOption] = useState(defaultValue);

  return (
    <RadioGroupHeadless
      value={selectedOption}
      onChange={(value) => {
        setSelectedOption(value);
        onChange?.(value);
      }}
      className={className}
    >
      <div className="flex flex-col gap-4">
        {items.map((item) => (
          <div className="flex gap-2 items-center mt-2" key={item.value}>
            <Radio
              key={item.value}
              value={item.value}
              className="group flex size-5 items-center justify-center rounded-full border bg-neutral-0 group-data-checked:bg-primary-300"
            >
              {({ checked }) => (
                <div
                  className={`${
                    checked ? 'bg-primary text-neutral-0' : 'bg-neutral-0'
                  } cursor-pointer size-2 rounded-full`}
                />
              )}
            </Radio>
            {item.content}
          </div>
        ))}
      </div>
    </RadioGroupHeadless>
  );
};
